import Seo from "../Components/Seo";
import { Container, Group, GroupLabel, GroupFooter, Row } from "../Components/ui";

// LINE公式アカウントID（@を含む）
const LINE_ID = "@camarago";
const lineUrl = (message) => `https://line.me/R/oaMessage/${LINE_ID}/?${encodeURIComponent(message)}`;
const mailUrl = (subject, body) =>
  `mailto:contact@camarago.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

// 押したボタンに応じて、LINEのメッセージが自動で入る
const LINE_OPTIONS = [
  { label: "現地調査の依頼をしたい", message: "現地調査をしてほしい" },
  { label: "カメラの設置について相談したい", message: "設置に関する相談" },
  { label: "商品に関する相談をしたい", message: "商品に関する相談" },
  { label: "その他", message: " " },
];

const MAIL = {
  subject: "防犯カメラについての相談",
  body: `以下の内容をご記入の上、お問い合わせください。
お名前：
電話番号：
ご用件：
`,
};

const BUSINESS_LINE_MESSAGE = "サイトに自社製品を掲載したい";
const BUSINESS_MAIL = {
  subject: "カメラ情報をcamaragoに掲載希望",
  body: `以下の内容をご記入の上、お問い合わせください。
会社名: 
お名前：
部署名:
役職:
電話番号：
掲載希望商品数:
その他: 

`,
};

const LineMark = () => (
  <span className="flex h-[30px] w-[30px] shrink-0 items-center justify-center rounded-[7px] bg-line-green text-[10px] font-bold tracking-tight text-white" aria-hidden="true">
    LINE
  </span>
);
const MailMark = () => (
  <span className="flex h-[30px] w-[30px] shrink-0 items-center justify-center rounded-[7px] bg-tint text-white" aria-hidden="true">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round">
      <rect x="1.5" y="3" width="13" height="10" rx="1.5" />
      <path d="M2 4l6 5 6-5" />
    </svg>
  </span>
);

export default function ContactForm() {
  return (
    <div className="bg-fill-2 pb-20">
      <Seo
        pageTitle="お問い合わせ"
        description="防犯カメラ・監視カメラの選定や設置に関するご相談はこちら。商品の比較から設置の相談まで、お気軽にお問い合わせください。"
        url="https://camarago.com/contact"
      />
      <Container narrow className="pt-10 md:pt-16">
        <h1 className="px-1 text-[32px] font-bold leading-tight tracking-tight md:text-[44px]">お問い合わせ</h1>
        <p className="mt-3 px-1 text-[15px] leading-relaxed text-ink-2 md:text-[17px]">
          商品の比較から設置のご相談まで、お気軽にお問い合わせください。専門スタッフが丁寧に対応いたします。返信には1営業日いただく場合がございます。
        </p>

        <h2 className="mt-12 px-1 text-[22px] font-bold">カメラの設置に関するご相談</h2>

        <div className="mt-5">
          <GroupLabel>LINEで相談する（スマートフォンにおすすめ）</GroupLabel>
          <Group>
            {LINE_OPTIONS.map((o) => (
              <Row key={o.label} href={lineUrl(o.message)} accessory="chevron" className="gap-3.5">
                <span className="flex items-center gap-3.5">
                  <LineMark />
                  <span>{o.label}</span>
                </span>
              </Row>
            ))}
          </Group>
          <GroupFooter>
            押した項目に合わせてメッセージが自動で入ります。そのまま送信してください。スマートフォン以外からはLINEが開けない場合があります。
          </GroupFooter>
        </div>

        <div className="mt-8">
          <GroupLabel>メールで相談する（社内で共有したいときに）</GroupLabel>
          <Group>
            <Row href={mailUrl(MAIL.subject, MAIL.body)} accessory="chevron">
              <span className="flex items-center gap-3.5">
                <MailMark />
                <span>メールで問い合わせる</span>
              </span>
            </Row>
          </Group>
          <GroupFooter>お名前・電話番号・ご用件の記入欄が入った状態でメールが開きます。</GroupFooter>
        </div>

        <h2 className="mt-14 px-1 text-[22px] font-bold">カメラ情報の掲載を希望するメーカー様</h2>

        <div className="mt-5">
          <Group>
            <Row href={lineUrl(BUSINESS_LINE_MESSAGE)} accessory="chevron">
              <span className="flex items-center gap-3.5">
                <LineMark />
                <span>LINEで掲載について問い合わせる</span>
              </span>
            </Row>
            <Row href={mailUrl(BUSINESS_MAIL.subject, BUSINESS_MAIL.body)} accessory="chevron">
              <span className="flex items-center gap-3.5">
                <MailMark />
                <span>メールで掲載について問い合わせる</span>
              </span>
            </Row>
          </Group>
          <GroupFooter>
            LINEでは「サイトに自社製品を掲載したい」というメッセージが入ります。メールには会社名・ご担当者名・掲載希望商品数などの記入欄が入ります。
          </GroupFooter>
        </div>
      </Container>
    </div>
  );
}
